var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMepassLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 54,
    viewBox: "0 0 53 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.252 15.9805H5.99559C7.73674 15.9805 9.15264 17.3939 9.15264 19.1375V52.5617C9.15264 53.2293 8.60976 53.7697 7.9446 53.7697H1.27836C0.610753 53.7697 0.0703125 53.2268 0.0703125 52.5617V20.1646C0.0703125 17.8561 1.94351 15.9829 4.252 15.9829V15.9805Z",
    fill: "#CB2027"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M5.99559 15.979H4.252C1.94107 15.979 0.0703125 17.8522 0.0703125 20.1607V21.7576C0.0703125 22.9289 0.598526 24.0391 1.50823 24.7777L9.1502 30.9817V19.1336C9.1502 17.39 7.73674 15.9766 5.99314 15.9766L5.99559 15.979Z",
    fill: "url(#paint0_radial_13161_12153)"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3508 46.0074H36.1556V40.6177H45.6732C46.3506 40.6177 46.8788 40.0357 46.8128 39.3608C46.7395 38.6076 46.7003 37.8397 46.7003 37.0621C46.7003 36.1597 46.7517 35.272 46.8471 34.4014C46.9229 33.724 46.3898 33.1347 45.7075 33.1347H36.1532V28.1167H47.3484C47.994 28.1167 48.5858 27.7499 48.8621 27.1654C49.8549 25.0501 51.1583 23.172 52.699 21.6143C53.2467 21.0616 52.8677 20.125 52.0876 20.125H38.8187L27.0391 31.8044V52.8742C27.0391 53.4905 27.5379 53.9893 28.1542 53.9893H51.958C52.7846 53.9893 53.1832 52.9989 52.6085 52.4071C51.1094 50.869 49.8378 49.0227 48.8645 46.9489C48.5906 46.3645 47.9964 45.9977 47.3508 45.9977V46.0074Z",
    fill: "#CB2027"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0798 7.26048L48.7104 5.92772C47.9548 6.64668 46.8616 7.01839 45.6854 6.75917C44.4969 6.49751 43.531 5.55602 43.24 4.37488C42.949 3.20596 43.2913 2.10552 43.9883 1.33276L42.6188 0L17.7464 25.3689L8.52953 16.355C6.58052 14.406 3.41858 14.406 1.46957 16.355C-0.479439 18.304 -0.479439 21.466 1.46957 23.415L14.2176 35.9576C15.1542 36.8942 16.4234 37.42 17.7488 37.42C19.0742 37.42 20.3434 36.8942 21.28 35.9576L50.0798 7.26048Z",
    fill: "#FFD254"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M48.7767 5.91172C48.0211 6.63068 46.928 7.00238 45.7517 6.74317C45.0059 6.57932 44.348 6.14648 43.8883 5.55469L17.9716 32.0363L1.21798 16.6887C-0.41068 18.65 -0.305527 21.5625 1.53099 23.4014L14.279 35.9441C15.2156 36.8807 16.4848 37.4064 17.8102 37.4064C19.1356 37.4064 20.4048 36.8807 21.3414 35.9441L50.1462 7.24448L48.7767 5.91172Z",
    fill: "url(#paint1_radial_13161_12153)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.46,
    d: "M17.903 32.0562L17.8125 25.3581L42.6141 0.00390625L43.9835 1.33667C43.9835 1.33667 42.1788 3.12183 43.8197 5.5746L17.903 32.0562Z",
    fill: "url(#paint2_linear_13161_12153)"
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_13161_12153",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-3.07206 17.8082) scale(40.2836)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58595B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#434244",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#2B2829",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_13161_12153",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1.48494 19.9959) scale(42.2729 42.2729)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0CF23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3A41E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_13161_12153",
    x1: 17.9641,
    y1: 26.9232,
    x2: 52.611,
    y2: -3.77183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMepassLogo);
export default __webpack_public_path__ + "static/media/mepass-logo.f36e4ba2ed9662ac05c85cdc1ebbe594.svg";
export { ForwardRef as ReactComponent };